// extracted by mini-css-extract-plugin
export default {"featured-locations":"_bf4Ji"};